var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"page-successfully-loaded-indicator"})
}
var staticRenderFns = []

export { render, staticRenderFns }